import classNames from 'classnames';
import React from 'react';
import Button from '../../../../components/Button';
import PaddingBox from '../../../../components/PaddingBox';
import classes from './styles/index.module.scss';
import { ExclamationCircleO } from '../../../../components/Icons/ExclamationCircleO';
import { CheckMarkCircleO } from '../../../../components/Icons/CheckMarkCircleO';

const AuthenticationMessage = (props) => {
	const { danger, message, buttonText, onButtonClick } = props;

	const AuthenticationIcon = danger ? ExclamationCircleO : CheckMarkCircleO;

	const iconClasses = classNames(classes.icon, {
		[classes.icon_danger]: danger,
	});

	return (
		<PaddingBox
			topSmall
			bottomTiny
		>
			<div className={classes.authenticationSuccessMessage}>
				<AuthenticationIcon className={iconClasses} />
				<div className={classes.message}>{message}</div>
				<Button
					primary
					block
					className={classes.button}
					size='small'
					onClick={onButtonClick}
				>
					{buttonText}
				</Button>
			</div>
		</PaddingBox>
	);
};

export { AuthenticationMessage };
